(function(){
  function cop(c){ return '$ ' + Math.round(c/100).toLocaleString('es-CO'); }
  // foto de la variante: en la plantilla llega como nombre de archivo del CDN de la tienda
  function fotoVar(v){
    if (v.img.indexOf('/') === -1) return '/cdn/shop/files/' + v.img + '?width=560';
    return (v.img.indexOf('http') === 0 ? v.img : 'https:' + v.img) + '?width=640';
  }
  document.querySelectorAll('.ficha[data-ficha]').forEach(function(card){
    var datos;
    try { datos = JSON.parse(card.getAttribute('data-ficha')); } catch(e){ return; }
    // moda: "Pedir por WhatsApp" (.f-wa) + "Agregar al carrito" (.f-add);
    // uniformes: solo .f-add. El carrito separa la moda y la manda a WhatsApp.
    var btns = [].slice.call(card.querySelectorAll('button.f-add, button.f-wa'));
    if (!btns.length) return;
    var btnCart = card.querySelector('button.f-add');
    var btnWa = card.querySelector('button.f-wa');
    var precioEl = card.querySelector('.f-price');
    var sel = new Array(datos.opts).fill(null);
    // si solo hay una variante, queda seleccionada de una (agregar en 1 clic)
    if (datos.vars.length === 1 && datos.vars[0].av) sel = datos.vars[0].o.slice();
    function variante(){
      return datos.vars.find(function(v){
        return v.o.every(function(x,i){ return sel[i] === x; });
      }) || null;
    }
    function compatible(gi, val){
      // ¿existe variante disponible con este valor y las demás selecciones actuales?
      return datos.vars.some(function(v){
        if (!v.av || v.o[gi] !== val) return false;
        return v.o.every(function(x,i){ return i === gi || sel[i] === null || sel[i] === x; });
      });
    }
    var fotoPuesta = '';
    function pinta(){
      card.querySelectorAll('.f-chip').forEach(function(ch){
        var gi = +ch.getAttribute('data-g'), val = ch.getAttribute('data-v');
        ch.classList.toggle('on', sel[gi] === val);
        ch.classList.toggle('no', !compatible(gi, val));
      });
      var v = variante();
      btns.forEach(function(b){ b.disabled = !(v && v.av); });
      // la foto sigue al color elegido aunque falte la talla
      var conFoto = v || datos.vars.find(function(x){
        return x.img && x.o.every(function(o,i){ return sel[i] === null || sel[i] === o; });
      });
      if (v && precioEl) precioEl.textContent = cop(v.p);
      if (conFoto && conFoto.img && sel.some(function(x){ return x !== null; }) && conFoto.img !== fotoPuesta){
        fotoPuesta = conFoto.img;
        if (window.succoFotos) window.succoFotos.ir(card, conFoto.img, fotoVar(conFoto));
        else {
          var img = card.querySelector('.f-photo img, .fc img');
          if (img) img.src = fotoVar(conFoto);
        }
      }
    }
    card.addEventListener('click', function(e){
      var ch = e.target.closest('.f-chip');
      if (!ch) return;
      var gi = +ch.getAttribute('data-g'), val = ch.getAttribute('data-v');
      sel[gi] = (sel[gi] === val) ? null : val;
      pinta();
    });
    if (btnWa) btnWa.addEventListener('click', function(){
      var v = variante();
      if (!v || !v.av) return;
      // moda: sin inventario en línea → chat con la tienda Succo que elija el cliente
      window.succoTienda.pedir('Quiero pedir: ' + datos.nombre +
        (datos.ref ? ' (Ref. ' + datos.ref + ')' : '') +
        ' — ' + v.o.join(' / ') + ' — ' + cop(v.p));
    });
    if (btnCart){
      var txt0 = btnCart.textContent;
      btnCart.addEventListener('click', function(){
        var v = variante();
        if (!v || !v.av) return;
        var item = {
          variantId: v.id, handle: datos.handle, nombre: datos.nombre,
          variante: v.o.join(' / '), precio: v.p, foto: datos.foto, qty: 1
        };
        if (datos.wa){ item.moda = true; item.ref = datos.ref; }
        window.succoCart.add(item);
        btnCart.classList.add('ok');
        btnCart.textContent = '✓ Agregado';
        setTimeout(function(){
          btnCart.classList.remove('ok');
          btnCart.textContent = txt0;
        }, 1600);
      });
    }
    pinta();
  });
})();
